import { useMemo } from 'react';
import styled from 'styled-components';
import { getColorPositionInGradient } from '../../utils/colors';
import { TilesetKey } from '../../types/tileset';

interface ContinuousKeyProps {
  keys: TilesetKey[];
  colorToHighlight: Nullable<string>;
}

const Gradient = styled.div`
  background-color: transparent;
  background-image: ${({ options }: { options: TilesetKey[] }) =>
    `-webkit-linear-gradient(left, ${options
      .map(({ hexCode }) => hexCode)
      .join(', ')})`};
  border-radius: 20px;
  min-height: 12px;

  position: relative;
`;

const GradientPosition = styled.div`
  width: 0;
  height: 100%;
  border-left: 1px solid black;
  border-right: 1px solid black;

  content: '';
  position: absolute;
  top: 0;
  /* NOTE: 'left' is set w/ inline style */
`;

const ContinuousKey = ({ keys, colorToHighlight }: ContinuousKeyProps) => {
  const gradientColors = keys.map(({ hexCode }) => hexCode);

  const highlightedPosition = useMemo(
    () =>
      colorToHighlight
        ? getColorPositionInGradient(colorToHighlight, gradientColors)
        : null,
    [colorToHighlight, gradientColors],
  );

  return (
    <div className="my-2">
      <Gradient options={keys}>
        {highlightedPosition != null && (
          <GradientPosition style={{ left: `${highlightedPosition * 100}%` }} />
        )}
      </Gradient>
      <div className="d-flex justify-content-between">
        {keys.map((keyEntry) => (
          <div key={keyEntry.hexCode}>{keyEntry.label || ''}</div>
        ))}
      </div>
    </div>
  );
};

export default ContinuousKey;
